var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.pageTransition}},[_c('router-view')],1),_c('audio',{attrs:{"src":_vm.url,"loop":"","id":"alarm","hidden":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }